import React, { useState, useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";
import { TextField, Button as MuiButton, Grid } from "@material-ui/core";
import Button from "../common/button/button";
import { useLocalizedName } from "../../globals/langHelpers";
import "moment-timezone";
import { Caption, Value } from "./workOrderDetails";
import { fetchBillingComments, updateContractorComment, addContractorComment } from "../../redux/billing/billingActions";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

const messages = defineMessages({
    addYourComments: {
        id: "task-incomplete-form.add-your-comments",
        defaultMessage: "Add your comments here",
        description: "Add your comments here caption",
    },
    contractorComments: {
        id: "admin.work-order-details.contractor-comments",
        defaultMessage: "Contractor comments",
        description: "Contractor comments caption",
    },
});
export const useStylesBellAndContractorComments = makeStyles({
    divtext: {
        wordBreak: "break-all",
        whiteSpace: "pre-wrap",
    },
    inputAdornmentArea: {
        backgroundColor: "auto",
        right: "0px",
        bottom: "0px",
    },
    divArea: {
        backgroundColor: "auto",
        width: "10%",
        color: "auto",
        position: "absolute",
        right: "0px",
        bottom: "0px",
        fontSize: "90%",
        textAlign: "center",
    },
});
const BellAndContractorComments = (props) => {
    const { workorderData = {}, readOnly, comments = [] } = props;
    const { workOrderId } = workorderData;
    const [addComments, setAddComments] = useState(false);
    const [contractorCommentNew, setContractorCommentNew] = useState(null);
    const [contractorComment, setContractorComment] = useState(null);
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();
    const classes = useStylesBellAndContractorComments();
    const [contractorCommentsEditIndex, setContractorCommentsEditIndex] = useState(null);

    useEffect(() => {
        if (workOrderId) props.fetchBillingComments(workOrderId);
    }, [workOrderId]);

    const save = () => {
        if (addComments) {
            const newComment = {
                comment: contractorCommentNew,
                createdBy: "",
                createdDate: "",
                workOrderId: workOrderId,
                commentType: 2,
            };
            props.addContractorComment(newComment);
            cancelShowAddCommentsBox();
            setContractorCommentNew(null);
        } else {
            props.updateContractorComment(comments[contractorCommentsEditIndex], contractorComment);

            // close editing mode
            setContractorCommentsEditIndex(null);
        }
    };

    const showAddCommentsBox = () => {
        setAddComments(true);
    };

    const cancelShowAddCommentsBox = () => {
        setAddComments(false);
    };

    return (
        <>
            <Grid container style={{ maxHeight: "400px", overflowY: "auto" }}>
                {comments.map((comment, index) => (
                    <Grid key={comment.id || index} item md={12} style={{ paddingTop: "5px", paddingBottom: "15px" }}>
                        <Caption>
                            {getLocalizedName({ object: comment.commentType })}
                            <span>
                                {intl.locale == "en" ? "saved on" : "enregistré le"}
                                {moment.utc(new Date(comment.updatedDate ? comment.updatedDate : comment.createdDate)).format("LLLL")}
                            </span>
                        </Caption>
                        {/* as per FMSNUC-9997 contractor shouldn't edit the comments */}
                        {/* {comment.commentType && comment.commentType.id == 2 &&
                            <MuiButton
                                className="no-print"
                                disabled={readOnly}
                                onClick={() => {
                                    setContractorCommentsEditIndex(index)
                                    setContractorComment(comment.comment)
                                }}>
                                <FormattedMessage
                                    id='admin.work-order-details.edit'
                                    defaultMessage='Edit'
                                    description='Admin work order edit button'
                                />
                            </MuiButton>
                        } */}
                        {contractorCommentsEditIndex == index && comment.commentType && comment.commentType.id == 2 ? (
                            <>
                                <TextField
                                    id="additional-comments"
                                    placeholder={intl.formatMessage(messages.addYourComments)}
                                    multiline
                                    fullWidth
                                    rows={5}
                                    variant="outlined"
                                    InputProps={{
                                        inputProps: { maxLength: 2000 },
                                        endAdornment: (
                                            <InputAdornment component="div" className={classes.inputAdornmentArea}>
                                                <div className={classes.divArea}>{`${contractorComment ? contractorComment.length : 0}/2000`}</div>
                                            </InputAdornment>
                                        ),
                                    }}
                                    style={{
                                        paddingBottom: 10,
                                    }}
                                    value={contractorComment}
                                    onChange={(e) => setContractorComment(e.target.value)}
                                />

                                <Grid item md={12}>
                                    <Button secondary onClick={save} style={{ float: "right" }}>
                                        <FormattedMessage
                                            id="admin.work-order-details.save-changes"
                                            defaultMessage="Save changes"
                                            description="Admin work order save changes button"
                                        />
                                    </Button>
                                    <Button
                                        tertiary
                                        onClick={() => {
                                            setContractorCommentsEditIndex(null);
                                            setContractorComment(comment.comment);
                                        }}
                                        style={{ float: "right" }}>
                                        <FormattedMessage
                                            id="admin.work-order-details.cancel-changes"
                                            defaultMessage="Cancel"
                                            description="Admin work order cancel changes button"
                                        />
                                    </Button>
                                </Grid>
                            </>
                        ) : (
                            <div className={classes.divtext}>
                                <Value>{comment ? comment.comment : ""}</Value>
                            </div>
                        )}
                    </Grid>
                ))}
            </Grid>
            {addComments && (
                <>
                    <Grid item md={12}>
                        <Caption>{intl.formatMessage(messages.contractorComments)}</Caption>
                        <TextField
                            id="additional-comments"
                            placeholder={intl.formatMessage(messages.addYourComments)}
                            multiline
                            fullWidth
                            rows={4}
                            variant="outlined"
                            InputProps={{
                                inputProps: { maxLength: 2000 },
                                endAdornment: (
                                    <InputAdornment component="div" className={classes.inputAdornmentArea}>
                                        <div className={classes.divArea}>{`${contractorCommentNew ? contractorCommentNew.length : 0}/2000`}</div>
                                    </InputAdornment>
                                ),
                            }}
                            style={{
                                paddingBottom: 10,
                            }}
                            value={contractorCommentNew}
                            onChange={(e) => setContractorCommentNew(e.target.value)}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <Button secondary onClick={save} style={{ float: "right" }}>
                            <FormattedMessage
                                id="admin.work-order-details.save-changes"
                                defaultMessage="Save changes"
                                description="Admin work order save changes button"
                            />
                        </Button>
                        <Button tertiary onClick={() => cancelShowAddCommentsBox()} style={{ float: "right" }}>
                            <FormattedMessage
                                id="admin.work-order-details.cancel-changes"
                                defaultMessage="Cancel"
                                description="Admin work order cancel changes button"
                            />
                        </Button>
                    </Grid>
                </>
            )}

            {
                <Grid container style={{ borderTop: comments && comments.length ? "1px solid rgb(212, 212, 212)" : "none" }}>
                    <Grid item md={12} style={{ paddingTop: "10px" }}>
                        <Button secondary disabled={readOnly} onClick={() => showAddCommentsBox()} style={{ float: "left" }}>
                            <FormattedMessage
                                id="admin.work-order-details.add-comment-button-caption"
                                defaultMessage="Add Comment +"
                                description="Admin work order Add Contractor Comment button caption"
                            />
                        </Button>
                    </Grid>
                </Grid>
            }
        </>
    );
};

const mapStateToProps = (state, prevProps) => {
    return {
        comments: state.billing.comments,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            addContractorComment,
            updateContractorComment,
            fetchBillingComments,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(BellAndContractorComments);
